import "antd/lib/button/style";
import _Button from "antd/lib/button";
var __jsx = React.createElement;
import "core-js/modules/es6.string.link.js";
import React from 'react';
var LinkButton = function LinkButton(_ref) {
  var icon = _ref.icon,
    link = _ref.link,
    text = _ref.text,
    collapsed = _ref.collapsed;
  return __jsx("a", {
    href: link,
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      textDecoration: 'none'
    }
  }, __jsx(_Button, {
    type: "text",
    icon: icon,
    style: {
      color: 'hsla(0, 0%, 100%, .65)'
    }
  }, !collapsed && text));
};
export default LinkButton;